import React, { useEffect, useState } from "react";

import { useDex } from "../../hooks/useDex";
import { useNavigator } from "../../hooks/useNavigator";

import toast from 'react-simple-toasts';

import ReactTooltip from 'react-tooltip';

import classNames from "classnames";

import { wethAddress } from "../../utils/tools";
import { swaps } from "../../utils/data";
import dexscreenerlogo from "../../icons/logo_dexscreener.png";
import {ReactComponent as HealthIcon} from '../../icons/svgs/health.svg';
import {ReactComponent as Marquee} from '../../icons/svgs/marquee.svg';

export function DexToolBarLinksOut({ addClass, disabled=false }) {

    const navigator = useNavigator();

    let { contractAddress, handleContractAddress, screens } = useNavigator();

    let { handleHealthCheck,
        dexChartVisible,
        handleDexChartVisible,
        handleSwapVisible,
        apeSettings,
        token,
        dexView,
        showTicker,
        handleShowTicker,
        swapExchange
    } = useDex();


    useEffect(() => {
        ReactTooltip.rebuild();
    }, [] );




    // const openExternal = (e,ape=true) => {

    //     e.preventDefault();
    //     e.stopPropagation();

    //     if(dexView=="swap"){
    //         let q = '';
    //         if(swaps[swapExchange].custom !== undefined){
    //             q = `${token.address}`;
    //         }else{
    //             q = `?theme=dark&outputCurrency=${token.pair.data.baseToken.address}`;

    //             if(ape){
    //                 q += `&inputCurrency=${ token.pair.data.quoteToken.address == wethAddress ? 'eth' : token.pair.data.quoteToken.address}&slippage=${apeSettings.slippage*100}&exactAmount=${apeSettings.amount}&exactField=input`;
    //             }
    //         }


    //         window.open(
    //             `${swaps[swapExchange].url}${q}`,
    //             '_blank',
    //             'toolbar=0,status=0,width=600,height=700,left=1000,top=100'
    //         );


    //     }else if(dexView=="chart"){
    //         let child = window.open(
    //             `https://dexscreener.com/ethereum/${token.pair.data.pairAddress}?theme=dark`,
    //             // `https://dexscreener.com/ethereum/${token.pair.data.pairAddress}?embed=1&theme=dark&info=0`,
    //             // `https://www.dextools.io/app/en/ether/pair-explorer/${token.pair.data.pairAddress}`,
    //             '_blank',
    //             'toolbar=0,status=0,width=600,height=700,left=100,top=100'
    //         );
    //     }


    // }

    const openUniswap = (e, ape=true) => {

        e.preventDefault();
        e.stopPropagation();

        let q = `outputCurrency=${token.pair.data.baseToken.address}`;

        if(ape){
            q += `&inputCurrency=${ token.pair.data.quoteToken.address == wethAddress ? 'eth' : token.pair.data.quoteToken.address}&slippage=${apeSettings.slippage*100}&exactAmount=${apeSettings.amount}&exactField=input`;
        }

        let weth = "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2";
        window.open(
            `https://app.uniswap.org/#/swap?${q}`,
            '_blank',
            'toolbar=0,status=0,width=600,height=700,left=1000,top=100'
        );
    }

    const openDexScreener = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let child = window.open(
            `https://dexscreener.com/ethereum/${token.pair.data.pairAddress}?theme=dark`,
            // `https://dexscreener.com/ethereum/${token.pair.data.pairAddress}?embed=1&theme=dark&info=0`,
            // `https://www.dextools.io/app/en/ether/pair-explorer/${token.pair.data.pairAddress}`,
            'chart',
            'toolbar=0,status=0,width=600,height=700,left=100,top=100'
        );


    }



    const openDexTools = (e) => {
        e.preventDefault();
        e.stopPropagation();
        // window.location.href = `https://www.dextools.io/`
        window.open(
            `https://www.dextools.io/ether/pair-explorer/${token.pair.data.pairAddress}`,
            // `https://opensea.io/assets/ethereum/${ca}/${nft.token_id}`
            'dextools'
            // 'toolbar=0,status=0,width=548,height=325'
        );
    }

    const openEtherscan = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.open(
            `https://etherscan.io/token/${token.pair.data.baseToken.address}`,
            'etherscan'
            // 'toolbar=0,status=0,width=548,height=325'
        );
    }

    const showQRModal = (e) => {
        // e.preventDefault();
        // e.stopPropagation();
        // handleModalTitle(nft.name + ' - #' + nft.token_id);
        // let qu = `${process.env.REACT_APP_ARTEMIS_URL_IP}/assets/${ca}/${nft.token_id}`;
        // console.log(qu);
        // handleQrurl(qu);
        // handleModalVisible(true);
        // handleQrModal(true);
    }

    const openQRUrl = (e) => {
        // e.preventDefault();
        // e.stopPropagation();
        //
        //
        // let qu = `${process.env.REACT_APP_ARTEMIS_URL_IP}/assets/${nft.token_address}/${nft.token_id}`;
        // window.open(
        //     qu,
        //     'qru'
        //     // 'toolbar=0,status=0,width=548,height=325'
        // );
    }

    const toggleShowTicker = () => {
        handleShowTicker(!showTicker);
    }



    return (


        <div style={{alignItems:'center'}} className={classNames("coin-links", disabled && 'disabled')}>


            {/*<div className="svg-icon">
                <div style={{fontSize:13,opacity:.7,marginRight:11}} className="icon-button-external-link"/>
            </div>*/}

            {/* <div onClick={() => { toggleShowTicker() } } data-tip={!showTicker ? "show marquee" : "hide marquee"} style={{maxWidth:120}} className={classNames("coin-link", showTicker && 'active')}>
                <div style={{width:14,height:14}} className="svg-icon">
                    <Marquee/>

                </div>
            </div> */}


            {/* { dexView == "chart" || dexView == "swap" ? (
                <div onClick={openExternal} style={{padding: "5px 5px 8px 8px"}} data-tip="open external" className="coin-link">
                    <div className="icon-button-external-link"></div>
                </div>
            ):null} */}





            {/*<div onClick={openDexScreener} data-tip="DexScreener" className="coin-link">
                <div className="svg-icon large">

                    <img style={{maxWidth:'100%',maxHeight:'100%'}} src={require(`../../icons/data/logo_dexscreener_mark.png`)}/>


                </div>
            </div>*/}

            {/*<div onClick={openDexTools} data-tip="DexTools" className="coin-link">
                <div className="svg-icon large">

                    <img style={{maxWidth:'100%',maxHeight:'100%'}} src={require(`../../icons/data/logo_dextools_mark.png`)}/>


                </div>
            </div>
*/}


            {/*<div onClick={openUniswap} data-tip="Uniswap" className="coin-link">
                <div style={{width:22,height:22}} className="svg-icon">

                    <svg width="641" height="640" viewBox="0 0 641 640" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M224.534 123.226C218.692 122.32 218.445 122.213 221.195 121.791C226.464 120.98 238.905 122.085 247.479 124.123C267.494 128.881 285.707 141.069 305.148 162.714L310.313 168.465L317.701 167.277C348.828 162.275 380.493 166.25 406.978 178.485C414.264 181.851 425.752 188.552 427.187 190.274C427.645 190.822 428.485 194.355 429.053 198.124C431.02 211.164 430.036 221.16 426.047 228.625C423.877 232.688 423.756 233.975 425.215 237.452C426.38 240.227 429.627 242.28 432.843 242.276C439.425 242.267 446.509 231.627 449.791 216.823L451.095 210.943L453.678 213.868C467.846 229.92 478.974 251.811 480.885 267.393L481.383 271.455L479.002 267.762C474.903 261.407 470.785 257.08 465.512 253.591C456.006 247.301 445.955 245.161 419.337 243.758C395.296 242.491 381.69 240.438 368.198 236.038C345.244 228.554 333.672 218.587 306.405 182.812C294.294 166.923 286.808 158.131 279.362 151.051C262.442 134.964 245.816 126.527 224.534 123.226Z" fill="#FF007A"/>
                        <path d="M432.61 158.704C433.215 148.057 434.659 141.033 437.562 134.62C438.711 132.081 439.788 130.003 439.954 130.003C440.12 130.003 439.621 131.877 438.844 134.167C436.733 140.392 436.387 148.905 437.84 158.811C439.686 171.379 440.735 173.192 454.019 186.769C460.25 193.137 467.497 201.168 470.124 204.616L474.901 210.886L470.124 206.405C464.282 200.926 450.847 190.24 447.879 188.712C445.89 187.688 445.594 187.705 444.366 188.927C443.235 190.053 442.997 191.744 442.84 199.741C442.596 212.204 440.897 220.204 436.797 228.203C434.58 232.529 434.23 231.606 436.237 226.723C437.735 223.077 437.887 221.474 437.876 209.408C437.853 185.167 434.975 179.339 418.097 169.355C413.821 166.826 406.776 163.178 402.442 161.249C398.107 159.32 394.664 157.639 394.789 157.514C395.267 157.038 411.727 161.842 418.352 164.39C428.206 168.181 429.833 168.672 431.03 168.215C431.832 167.909 432.22 165.572 432.61 158.704Z" fill="#FF007A"/>
                        <path d="M235.883 200.175C224.022 183.846 216.684 158.809 218.272 140.093L218.764 134.301L221.463 134.794C226.534 135.719 235.275 138.973 239.369 141.459C250.602 148.281 255.465 157.263 260.413 180.328C261.862 187.083 263.763 194.728 264.638 197.317C266.047 201.483 271.369 211.214 275.696 217.534C278.813 222.085 276.743 224.242 269.853 223.62C259.331 222.67 245.078 212.834 235.883 200.175Z" fill="#FF007A"/>
                        <path d="M418.223 321.707C362.793 299.389 343.271 280.017 343.271 247.331C343.271 242.521 343.437 238.585 343.638 238.585C343.84 238.585 345.985 240.173 348.404 242.113C359.644 251.128 372.231 254.979 407.076 260.062C427.58 263.054 439.119 265.47 449.763 269C483.595 280.22 504.527 302.99 509.518 334.004C510.969 343.016 510.118 359.915 507.766 368.822C505.91 375.857 500.245 388.537 498.742 389.023C498.325 389.158 497.917 387.562 497.81 385.389C497.24 373.744 491.355 362.406 481.472 353.913C470.235 344.257 455.137 336.569 418.223 321.707Z" fill="#FF007A"/>
                        <path d="M379.31 330.978C378.615 326.846 377.411 321.568 376.633 319.25L375.219 315.036L377.846 317.985C381.481 322.065 384.354 327.287 386.789 334.241C388.647 339.549 388.856 341.127 388.842 349.753C388.828 358.221 388.596 359.996 386.88 364.773C384.174 372.307 380.816 377.649 375.181 383.383C365.056 393.688 352.038 399.393 333.253 401.76C329.987 402.171 320.47 402.864 312.103 403.299C291.016 404.395 277.138 406.661 264.668 411.04C262.875 411.67 261.274 412.052 261.112 411.89C260.607 411.388 269.098 406.326 276.111 402.948C285.999 398.185 295.842 395.586 317.897 391.913C328.792 390.098 340.043 387.897 342.9 387.021C369.88 378.749 383.748 357.402 379.31 330.978Z" fill="#FF007A"/>
                        <path d="M404.719 376.105C397.355 360.273 395.664 344.988 399.698 330.732C400.13 329.209 400.824 327.962 401.242 327.962C401.659 327.962 403.397 328.902 405.103 330.05C408.497 332.335 415.303 336.182 433.437 346.069C456.065 358.406 468.966 367.959 477.74 378.873C485.423 388.432 490.178 399.318 492.467 412.593C493.762 420.113 493.003 438.206 491.074 445.778C484.99 469.653 470.85 488.406 450.682 499.349C447.727 500.952 445.075 502.269 444.788 502.275C444.501 502.28 445.577 499.543 447.18 496.191C453.965 482.009 454.737 468.214 449.608 452.859C446.467 443.457 440.064 431.985 427.135 412.596C412.103 390.054 408.417 384.054 404.719 376.105Z" fill="#FF007A"/>
                        <path d="M196.519 461.525C217.089 444.157 242.682 431.819 265.996 428.032C276.043 426.399 292.78 427.047 302.084 429.428C316.998 433.245 330.338 441.793 337.276 451.978C344.057 461.932 346.966 470.606 349.995 489.906C351.189 497.519 352.489 505.164 352.882 506.895C355.156 516.897 359.583 524.892 365.067 528.907C373.779 535.283 388.78 535.68 403.536 529.924C406.041 528.947 408.215 528.271 408.368 528.424C408.903 528.955 401.473 533.93 396.23 536.548C389.177 540.071 383.568 541.434 376.115 541.434C362.6 541.434 351.379 534.558 342.016 520.539C340.174 517.78 336.032 509.516 332.813 502.176C322.928 479.628 318.046 472.759 306.568 465.242C296.579 458.701 283.697 457.53 274.006 462.282C261.276 468.523 257.724 484.791 266.842 495.101C270.465 499.198 277.223 502.732 282.749 503.419C293.086 504.705 301.97 496.841 301.97 486.404C301.97 479.627 299.365 475.76 292.808 472.801C283.852 468.76 274.226 473.483 274.272 481.897C274.292 485.484 275.854 487.737 279.45 489.364C281.757 490.408 281.811 490.491 279.929 490.1C271.712 488.396 269.787 478.49 276.394 471.913C284.326 464.018 300.729 467.502 306.362 478.279C308.728 482.805 309.003 491.82 306.94 497.264C302.322 509.448 288.859 515.855 275.201 512.368C265.903 509.994 262.117 507.424 250.906 495.876C231.425 475.809 223.862 471.92 195.777 467.536L190.395 466.696L196.519 461.525Z" fill="#FF007A"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M49.6202 12.0031C114.678 90.9638 214.977 213.901 219.957 220.784C224.068 226.467 222.521 231.576 215.478 235.58C211.561 237.807 203.508 240.063 199.476 240.063C194.916 240.063 189.779 237.867 186.038 234.318C183.393 231.81 172.721 215.874 148.084 177.646C129.233 148.396 113.457 124.131 113.027 123.725C112.032 122.785 112.049 122.817 146.162 183.854C167.582 222.181 174.813 235.731 174.813 237.543C174.813 241.229 173.808 243.166 169.261 248.238C161.681 256.694 158.293 266.195 155.847 285.859C153.104 307.902 145.394 323.473 124.026 350.122C111.518 365.722 109.471 368.581 106.315 374.869C102.339 382.786 101.246 387.221 100.803 397.219C100.335 407.79 101.247 414.619 104.477 424.726C107.304 433.575 110.255 439.417 117.8 451.104C124.311 461.188 128.061 468.683 128.061 471.614C128.061 473.947 128.506 473.95 138.596 471.672C162.741 466.219 182.348 456.629 193.375 444.877C200.199 437.603 201.801 433.586 201.853 423.618C201.887 417.098 201.658 415.733 199.896 411.982C197.027 405.877 191.804 400.801 180.292 392.932C165.209 382.621 158.767 374.32 156.987 362.904C155.527 353.537 157.221 346.928 165.565 329.44C174.202 311.338 176.342 303.624 177.79 285.378C178.725 273.589 180.02 268.94 183.407 265.209C186.939 261.317 190.119 260 198.861 258.805C213.113 256.858 222.188 253.171 229.648 246.297C236.119 240.334 238.827 234.588 239.243 225.938L239.558 219.382L235.942 215.166C222.846 199.896 40.85 0 40.044 0C39.8719 0 44.1813 5.40178 49.6202 12.0031ZM135.412 409.18C138.373 403.937 136.8 397.195 131.847 393.902C127.167 390.79 119.897 392.256 119.897 396.311C119.897 397.548 120.582 398.449 122.124 399.243C124.72 400.579 124.909 402.081 122.866 405.152C120.797 408.262 120.964 410.996 123.337 412.854C127.162 415.849 132.576 414.202 135.412 409.18Z" fill="#FF007A"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M248.552 262.244C241.862 264.299 235.358 271.39 233.344 278.826C232.116 283.362 232.813 291.319 234.653 293.776C237.625 297.745 240.499 298.791 248.282 298.736C263.518 298.63 276.764 292.095 278.304 283.925C279.567 277.229 273.749 267.948 265.736 263.874C261.601 261.772 252.807 260.938 248.552 262.244ZM266.364 276.172C268.714 272.834 267.686 269.225 263.69 266.785C256.08 262.138 244.571 265.983 244.571 273.173C244.571 276.752 250.572 280.656 256.074 280.656C259.735 280.656 264.746 278.473 266.364 276.172Z" fill="#FF007A"/>
                    </svg>

                </div>
            </div>*/}



            {/*<div onClick={openDexTools} data-tip="open DexTools" className="coin-link">
                <div className="svg-icon">
                    <svg fill="none" height="2500" viewBox="0 -.058 754.779 867.058" width="2174" xmlns="http://www.w3.org/2000/svg">
                        <path clipRule="evenodd" d="m280.395 49.025c-51.649 26.905-93.905 49.672-93.896 50.598.023 2.39 123.959 65.156 128.358 65.003 2.001-.067 16.517-6.749 32.256-14.847l28.621-14.721 31.258 16.067 31.256 16.07 51.188-23.001c77.13-34.659 85.141-38.457 83.885-39.733-1.666-1.693-29.331-16.555-104.388-56.07-36.274-19.098-71.481-37.823-78.24-41.612-6.758-3.789-13.21-6.837-14.337-6.778s-44.311 22.12-95.961 49.024zm-226.532 117.306-53.766 27.772v121.886c0 67.038.706 121.885 1.572 121.885.863 0 27.316-11.467 58.783-25.482l57.213-25.482v-128.476l27.958 15.232a33224.294 33224.294 0 0 0 64.671 35.109l36.712 19.877 16.336-7.387a3822.03 3822.03 0 0 0 30.674-14.056c7.885-3.672 27.241-12.39 43.012-19.377 15.771-6.99 30.37-14.019 32.44-15.621 2.75-2.128-30.782-20.658-124.025-68.54-70.285-36.093-130.046-65.509-132.802-65.368s-29.206 12.752-58.778 28.028zm529.148 7.799c-36.618 16.531-66.604 30.717-66.638 31.526-.032.808 19.926 12.675 44.354 26.367 24.426 13.695 44.412 25.632 44.412 26.531 0 .897-21.615 11.37-48.03 23.278-26.419 11.905-93.194 42.061-148.393 67.014l-184.954 83.602c-46.525 21.032-88.462 39.989-93.193 42.132-95.03 43.019-121.15 54.956-124.737 57.005-3.607 2.063-4.424 14.048-5.066 74.201l-.766 71.744 48.08 24.498 48.079 24.497 66.669-30.088c36.669-16.547 66.669-30.953 66.669-32.014 0-1.058-6.776-5.473-15.054-9.815-8.282-4.342-25.378-13.954-37.995-21.364-12.616-7.411-25.196-14.21-27.958-15.112-2.761-.899-4.98-2.472-4.935-3.498.046-1.023 29.404-14.968 65.236-30.991 69.597-31.117 122.858-55.1 237.202-106.809a305577.39 305577.39 0 0 1 153.411-69.31c44.948-20.288 97.208-43.983 116.134-52.655l34.41-15.767.765-72.561.769-72.558-48.765-25.03c-26.822-13.765-49.748-24.994-50.95-24.953-1.201.038-32.141 13.595-68.756 30.13zm153.872 261.772c-7.186 3.51-21.38 10.082-31.542 14.603s-29.446 13.222-42.852 19.339l-24.374 11.117-.556 63.702c-.307 35.035-1.597 63.545-2.867 63.36-2.885-.429-48.567-23.857-94.487-48.463-33.143-17.757-35.225-18.463-43.013-14.606-4.502 2.231-31.413 14.3-59.801 26.825-28.389 12.523-52.541 23.587-53.677 24.589-1.133 1 56.002 31.967 126.97 68.819l129.029 67.003 55.119-28.513c30.312-15.68 56.088-29.983 57.275-31.782 2.672-4.045 2.443-242.93-.232-242.607-1.058.127-7.806 3.104-14.992 6.614zm-305.227 280.391a25013.26 25013.26 0 0 0 -28.675 12.349c-28.856 12.484-23.201 12.898-57.531-4.192-22.865-11.382-32.721-14.894-36.999-13.189-3.209 1.278-30.826 13.703-61.376 27.61-30.548 13.907-56.602 25.285-57.898 25.285-12.817 0 8.491 12.731 90.714 54.207l96.428 48.637 40.572-20.03c22.315-11.017 67.323-33.078 100.021-49.024 32.695-15.95 59.042-29.413 58.549-29.921-.497-.506-27.893-14.574-60.883-31.262l-59.982-30.338z" fill="#05a3c9" fillRule="evenodd"/>
                    </svg>

                </div>
            </div>*/}

            {/*<div onClick={openEtherscan} data-tip="view on etherscan" className="coin-link">
                <div className="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="293.775" height="293.667" viewBox="0 0 293.775 293.667">
                      <g id="etherscan-logo-light-circle" transform="translate(-219.378 -213.333)">
                        <path id="Path_1" data-name="Path 1" d="M280.433,353.152A12.45,12.45,0,0,1,292.941,340.7l20.737.068a12.467,12.467,0,0,1,12.467,12.467v78.414c2.336-.692,5.332-1.43,8.614-2.2a10.389,10.389,0,0,0,8.009-10.11V322.073a12.469,12.469,0,0,1,12.467-12.47h20.779a12.47,12.47,0,0,1,12.467,12.47v90.276s5.2-2.106,10.269-4.245a10.408,10.408,0,0,0,6.353-9.577V290.9a12.466,12.466,0,0,1,12.465-12.467h20.779A12.468,12.468,0,0,1,450.815,290.9v88.625c18.014-13.055,36.271-28.758,50.759-47.639a20.926,20.926,0,0,0,3.185-19.537,146.6,146.6,0,0,0-136.644-99.006c-81.439-1.094-148.744,65.385-148.736,146.834a146.371,146.371,0,0,0,19.5,73.45,18.56,18.56,0,0,0,17.707,9.173c3.931-.346,8.825-.835,14.643-1.518a10.383,10.383,0,0,0,9.209-10.306V353.152" transform="translate(0 0)" />
                        <path id="Path_2" data-name="Path 2" d="M244.417,398.641A146.808,146.808,0,0,0,477.589,279.9c0-3.381-.157-6.724-.383-10.049-53.642,80-152.686,117.405-232.79,128.793" transform="translate(35.564 80.269)" fill="#bfcfda"/>
                      </g>
                    </svg>

                </div>
            </div>*/}

            {/*<div onClick={showQRModal} data-tip="QR code" className="coin-link">
                <div className="svg-icon">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
                    <g><path d="M377.1,377.1H10V10h367.1V377.1z M78.6,308.5h229.8V78.6H78.6V308.5L78.6,308.5z"/><path d="M132.4,132.4h122.4v122.4H132.4V132.4z"/><path d="M377.1,990H10V621.8h367.1V990z M78.6,921.4h229.8v-231H78.6V921.4L78.6,921.4z"/><path d="M132.4,745.3h122.4v121.2H132.4V745.3z"/><path d="M990,377.1H621.8V10H990V377.1z M690.4,308.5h231V78.6h-231V308.5z"/><path d="M745.3,132.4h121.2v122.4H745.3V132.4z"/><path d="M10,377.1h122.4v123.5H10V377.1z"/><path d="M254.7,500.6h122.4v121.2H254.7V500.6L254.7,500.6z"/><path d="M500.6,10h121.2v122.4H500.6V10z"/><path d="M377.1,254.7h123.5v122.4H377.1V254.7z"/><path d="M500.6,866.5h121.2V990H500.6V866.5z"/><path d="M745.3,866.5H990V990H745.3V866.5z"/><path d="M500.6,621.8h244.7v123.5H500.6V621.8z"/><path d="M745.3,621.8h121.2v244.7H745.3V621.8z"/><path d="M855.1,621.8H990v123.5H855.1V621.8z"/><path d="M500.6,377.1h121.2v123.5H500.6V377.1z"/><path d="M621.8,500.6h123.5v121.2H621.8V500.6L621.8,500.6z"/><path d="M745.3,377.1h121.2v123.5H745.3V377.1z"/><path d="M866.5,500.6H990v121.2H866.5V500.6L866.5,500.6z"/></g>
                    </svg>

                </div>
            </div>*/}






        </div>

    )
}
